import { IOfficerScheduleViewModel } from "./IOfficerScheduleViewModel";
import { IScheduleViewModel } from "./IScheduleViewModel";

export class OfficerScheduleViewModel implements IOfficerScheduleViewModel {
  jobDate: Date;
  scheduleViewModel: IScheduleViewModel;

  constructor(jobDate: Date, scheduleViewModel: IScheduleViewModel) {
    this.jobDate = jobDate;
    this.scheduleViewModel = scheduleViewModel;
  }
}
